import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RecordLength, EActionType, EDataTableType } from '../../data/Constants';
import { QueueApi } from '../../api/QueueApi';
import { IPaginationRequest } from '../../../types/IApiTypes';
import { IQueue, IQueueData } from '../../../types';
import { updateMaintenanceRowData, updateTableData } from '../../store/utilities/SliceDataHelper';
import type { AppState } from '../AppStore';

export const queueInitialState: IQueue = {
  data: {},
  totalCount: 0,
  currentPage: 1,
  recordsPerPage: RecordLength[0],
  searchKey: '',
};

//This action call the getQueue api method to fetch the queues.
export const getQueue = createAsyncThunk(
  'queue/getQueue',
  async (action: IPaginationRequest, thunkAPI) => {
    return QueueApi.getQueueData(action, thunkAPI.dispatch);
  }
);

const queueSlice = createSlice({
  name: 'queue',
  initialState: queueInitialState,
  reducers: {},
  extraReducers: (builder) => {
    //To get the data to state
    builder.addCase(getQueue.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        if (action.meta.arg.caller === EActionType.Refresh) {
          updateMaintenanceRowData<IQueueData>(
            state.data,
            action.payload.data,
            state.currentPage,
            action.payload.searchKey,
            EDataTableType.Queue
          );
        } else {
          updateTableData(state, action.payload);
        }
      }
    });
  },
});

export const queue = (state: AppState) => state.queue;

export default queueSlice.reducer;
